import React from 'react';

const StarRating = ({ rating, setRating }) => {
  const handleClick = (index) => {
    setRating(index + 1);
  };

  return (
    <div className="star-rating">
      {[...Array(5)].map((star, index) => (
        <button
          key={index}
          type="button"
          className={index < rating ? "on star-button" : "off star-button"}
          onClick={() => handleClick(index)}
        >
          <span className="star">&#9733;</span>
        </button>
      ))}
    </div>
  );
};

export default StarRating;
